module.exports = __webpack_public_path__ + "static/IBMPlexSerif-Bold-07f82021dadd86bdcee95db733585607.woff";